import Card from 'features/common/components/Card'
import {ResponsiveContainer, BarChart, Bar, XAxis, Tooltip} from 'recharts'
import points from 'assets/points.svg'
import {useTranslation} from 'react-i18next'
import useStatistics from '../../common/hooks/useStatistics'
import Spinner from 'features/common/components/Spinner'

const YearChartCard = () => {
    const {t} = useTranslation()
    const {data, isLoading} = useStatistics()

    return (
        <Card className="col-span-3 flex min-h-0 flex-1 flex-col items-stretch justify-between gap-6 p-5">
            <div className="flex items-center justify-between">
                <div className="text-sm font-bold">
                    {t('STATISTICS_YEAR_TIPS')}
                </div>
                <div>
                    <img className="cursor-pointer" src={points} alt={'more'} />
                </div>
            </div>
            <div className="flex-1">
                {data ? (
                    <ResponsiveContainer height="100%" width="100%">
                        <BarChart data={data} barSize={16}>
                            <XAxis
                                tickLine={false}
                                tick={{
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    fill: '#000000',
                                }}
                                dataKey="name"
                                interval={0}
                            />
                            <Tooltip />
                            <Bar
                                dataKey="amount"
                                fill="#FFB800"
                                radius={[2, 2, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                ) : isLoading ? (
                    <div className="flex items-center justify-center">
                        <Spinner yellow={true} className="w-16" />
                    </div>
                ) : (
                    <div>no data</div>
                )}
            </div>
        </Card>
    )
}
export default YearChartCard
